import { GET_ATTENDANCE_RANGE, CLEAR_ATTENDANCE_RANGE } from 'actions/admin/attendance';

const initialState = {
  attendanceRange: [],
};

export default function attendance(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ATTENDANCE_RANGE:
      return { ...state, attendanceRange: action.attendanceRange };
    case CLEAR_ATTENDANCE_RANGE:
      return { ...state, attendanceRange: [] };
    default:
      return state;
  }
}
